module.exports = __webpack_public_path__ + "themes/fq/img/background@2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/background@2x.jpg
// module id = 56
// module chunks = d-game